import { Controller } from "@hotwired/stimulus";
import SlimSelect from "slim-select";

import { useMultiEmailInput } from "@bryq/employers-src/behaviors/use_multi_email_input";

export default class extends Controller {
  static targets = [
    "deletionEmailsField",
    "candidateDataRetentionPeriodField",
    "submitLogoButton",
  ];

  static values = {
    minCandidateDataRetentionPeriod: Number,
    maxCandidateDataRetentionPeriod: Number,
  };

  deletionEmailsFieldTargetConnected() {
    useMultiEmailInput(this, this.deletionEmailsFieldTarget);
  }

  candidateDataRetentionPeriodFieldTargetConnected(target) {
    // Prevents the select from being translated by Google Translate.
    // On this page, when the select gets translated, the SlimSelect library
    // will change the DOM for it which will trigger a new translation by
    // Google Translate, which will change the DOM again, and so on.
    // Checking the value of the select in the submit method is not enough to
    // get the translation to work...
    target.classList.add("notranslate");

    this.candidateDataRetentionPeriodSelect = new SlimSelect({
      select: target,
      settings: {
        searchPlaceholder: "Months",
      },
      events: {
        addable: (value) => {
          const trimmed = value.trim();
          const valueExists = this.candidateDataRetentionPeriodSelect
            .getData()
            .map((item) => item.value)
            .includes(trimmed);
          const number = parseInt(trimmed, 10);
          const isValid =
            !valueExists &&
            Number.isInteger(number) &&
            number >= this.minCandidateDataRetentionPeriodValue &&
            number <= this.maxCandidateDataRetentionPeriodValue;
          return isValid ? { text: `${trimmed} months`, value: number } : false;
        },
      },
    });
  }

  candidateDataRetentionPeriodFieldTargetDisconnected() {
    this.candidateDataRetentionPeriodSelect?.destroy();
  }

  /**
   * Submits the logo from the preview.
   */
  submitLogo() {
    if (this.hasSubmitLogoButtonTarget) {
      this.submitLogoButtonTarget.click();
    }
  }
}
